export default __webpack_public_path__ + "static/media/pexels-pixabay-263337.cca8b945.jpg";